module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }), _c('a', {
    attrs: {
      "id": "page3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/OEBPS/toc.htm#p1-ack"
    }
  }, [_vm._v("ACKNOWLEDGEMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("I’d like to thank Linzi Moody for her much-tried patience, her support and for the constant flow of ideas and suggestions that have made this a better book than it would otherwise have been; Christine Hamilton, Mary Timlin and Jennifer Young for helpful suggestions and for bearing with me while we trawled the delights of the City of Culture; my journalistic colleagues who couldn’t be more different from the heartless hacks I sometimes portray; Simon Travers, who explained the myth of fingerprints; and last but not least, my agents, Jane Gregory and Lisanne Radice whose unfailing good humour and encouragement help to keep me sane.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39aeee9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/p1-ack.vue
// module id = 81
// module chunks = 0